import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE = import.meta.env.VITE_SITE_NAME || 'ODRA';
const SITE_URL = (import.meta.env.VITE_SITE_URL || '').replace(/\/$/, '');

interface Props {
  title?: string;
  description?: string;
  image?: string;
  noindex?: boolean;
  jsonLd?: object;
}

/** Per-page title, description, canonical URL, social previews and structured data. */
export function Seo({ title, description, image, noindex, jsonLd }: Props) {
  const { pathname } = useLocation();
  const full = title ? `${title} — ${SITE}` : `${SITE} — Clothing on the rail`;
  const url = SITE_URL ? SITE_URL + pathname : undefined;
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      {url && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex" />}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
